import {
    Close, ErrorRounded, InfoRounded, WarningRounded,
} from '@mui/icons-material';
import {
    Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography,
} from '@mui/material';
import React from 'react';
import useStore from '../../store/store';
import { AlertBoxData } from '../types';
import ActionButton from '../ActionButton/ActionButton';
import { isValidFunction } from '../../utils/nullChecks';
import { Store } from '../../store/types';
import { AlertBoxType } from '../types/AlertBoxData';

const AlertBox = () => {
    const alertBox: AlertBoxData = useStore((state: Store) => state.alertBox)!;
    const showAlertBox = useStore((state: Store) => state.showAlertBox);

    const {
        show,
        messageNode,
        title,
        acceptText,
        acceptCallback,
        cancelText,
        cancelCallback,
        type,
    } = alertBox || {};

    const handleCancel = () => {
        showAlertBox({ ...alertBox, show: false });
        if (isValidFunction(cancelCallback)) {
            cancelCallback();
        }
    };
    const handleAccept = () => {
        showAlertBox({ ...alertBox, show: false });
        if (isValidFunction(acceptCallback)) {
            acceptCallback();
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter') {
            handleAccept();
        }
    };

    const getTitleIcon = (titleType: AlertBoxType) => {
        switch (titleType) {
            case AlertBoxType.INFO:
                return <InfoRounded color="info" />;
            case AlertBoxType.WARNING:
                return <WarningRounded color="warning" />;
            case AlertBoxType.ERROR:
                return <ErrorRounded color="error" />;
            default:
                return null;
        }
    };

    const getButtonColor = (titleType: AlertBoxType | null) => {
        switch (titleType) {
            case AlertBoxType.INFO:
                return 'info';
            case AlertBoxType.WARNING:
                return 'warning';
            case AlertBoxType.ERROR:
                return 'error';
            default:
                return 'primary';
        }
    };

    return (
        <Dialog
            open={show || false}
            sx={{ zIndex: 99999 }}
            maxWidth="md"
            onKeyDown={handleKeyDown}
            disableRestoreFocus
        >
            <DialogTitle id="form-dialog-title">
                <Grid container justifyContent="space-between">
                    <Grid item container sm={10} spacing={1} alignItems="center">
                        {
                            type && (
                                <>
                                    {getTitleIcon(type)}
                            &nbsp;
                            &nbsp;
                                </>
                            )
                        }
                        {title}
                    </Grid>
                    <IconButton aria-label="delete" onClick={handleCancel}>
                        <Close test-id={`${title}-close`} />
                    </IconButton>
                </Grid>
            </DialogTitle>
            <DialogContent
                sx={{ minWidth: 600, paddingTop: '0.5rem' }}
            >
                <Typography>
                    {messageNode}
                </Typography>
            </DialogContent>
            <DialogActions>
                {
                    cancelText && (
                        <ActionButton
                            test-id="cancel"
                            variant="outlined"
                            onClick={handleCancel}
                            color={getButtonColor(type || null)}
                        >
                            {cancelText || 'Cancel'}
                        </ActionButton>
                    )
                }
                <ActionButton
                    variant="contained"
                    test-id="confirm"
                    onClick={handleAccept}
                    color={getButtonColor(type || null)}
                >
                    {acceptText ?? 'OK'}
                </ActionButton>
            </DialogActions>
        </Dialog>
    );
};

export default AlertBox;
